import React, { useState, useEffect } from 'react'
import './updateBB.css'
import axios from 'axios'

const UpdateBB = () => {
  const [bank, setBank] = useState({name: '', address: '', contact: '', opening_hours: '', longitude: '', latitude: ''})

  const {name, address, contact, opening_hours, longitude, latitude} = bank

  useEffect(() => {
    const urlPathname = window.location.pathname
    const urlID = urlPathname.split('/')
    axios.get('https://blood147.000webhostapp.com/admin_panel/selectBloodbanks.php/?bbid=' + urlID[2])
    .then(response => response.data)
    .then((data) => {
      data.map((bb)=>{
        setBank({name: bb.name, address: bb.address, contact: bb.contact, opening_hours: bb.opening_hours, longitude: bb.longitude, latitude: bb.latitude})
      })
    })
    .catch(function (error) {
      // handle error
      console.log(error);
    })
    .then(function () {
      // always executed
    });
  }, [])
  
  const handleChange = e => {
    setBank({ ...bank, [e.target.name]: e.target.value })
  }

  const handleSubmit = e => {
    e.preventDefault()

    const checkName = document.getElementById('name').value
    const checkAddress = document.getElementById('address').value
    const checkContact = document.getElementById('contact').value
    const checkOpening_hours = document.getElementById('opening_hours').value
    const checkLongitude = document.getElementById('longitude').value
    const checkLatitude = document.getElementById('latitude').value

    if(checkName == '' || checkAddress == '' || checkContact == '' || checkOpening_hours == '' || checkLongitude == '' || checkLatitude == ''){
      document.getElementById('errorName').style.display = 'block'
      document.getElementById('errorAddress').style.display = 'block'
      document.getElementById('errorContact').style.display = 'block'
      document.getElementById('errorOpening_hours').style.display = 'block'
      document.getElementById('errorLatitude').style.display = 'block'
      document.getElementById('errorLongitude').style.display = 'block'
      return
    }
    else{
      document.getElementById('errorName').style.display = 'none'
      document.getElementById('errorAddress').style.display = 'none'
      document.getElementById('errorContact').style.display = 'none'
      document.getElementById('errorOpening_hours').style.display = 'none'
      document.getElementById('errorLatitude').style.display = 'none'
      document.getElementById('errorLongitude').style.display = 'none'
    }

    updateFunction();
  }

  const updateFunction = () => {
    const urlPathname = window.location.pathname
    const urlID = urlPathname.split('/')

    let formData = new FormData();
    formData.append('name', name)
    formData.append('address', address)
    formData.append('contact', contact)
    formData.append('opening_hours', opening_hours)
    formData.append('longitude', longitude)
    formData.append('latitude', latitude)
    
    axios({
        method: 'post',
        url: 'https://blood147.000webhostapp.com/admin_panel/updateBloodbanks.php/?bbid=' + urlID[2],
        data: formData,
        config: { headers: {'Content-Type': 'multipart/form-data' }}
    })
    .then(function (response) {
        if(response.data == 'failed'){
          alert('Update failed!!!\nRecheck your entries.\nMaybe try again later.')
        }
        else{
          alert('Update successful!!!')
          window.history.go(-1)
        }  
    })
    .catch(function (response) {
        //handle error
        console.log(response)
    });
  }

  return(
    <div className="updateBB">
        <div className="updateBBContainer">
          <div className="updateBBForm">
            <div className="updateBBFormDiv">
              <div className="updateBBInputWrapper">
                <label htmlFor="name" className='updateBBLabel'>Blood Bank Name:</label>
                <p id='errorName' className='errorMessage'>Please fill in alphabets!</p>
                <input id='name' type="text" className="updateBBInput" placeholder="Red Cross Blood Bank" name="name" value={name} onChange={e => handleChange(e)}/> 
              </div>
              <div className="updateBBInputWrapper">
                <label htmlFor="address" className='updateBBLabel'>Address:</label>
                <p id='errorAddress' className='errorMessage'>Please fill the address!</p>
                <input id='address' type="text" className="updateBBInput" placeholder="Street, City, Country" name="address" value={address} onChange={e => handleChange(e)}/> 
              </div>
            </div>
            
            <div className="updateBBFormDiv">
              <div className="updateBBInputWrapper">
                <label htmlFor="contact" className='updateBBLabel'>Contact:</label>
                <p id='errorContact' className='errorMessage'>Please fill the contact!</p>
                <input id='contact' type="number" className="updateBBInput" placeholder="+977-512345" name="contact" value={contact} onChange={e => handleChange(e)}/> 
              </div>
              <div className="updateBBInputWrapper">
                <label htmlFor="opening_hours" className='updateBBLabel'>Opening Hours:</label>
                <p id='errorOpening_hours' className='errorMessage'>Please fill the opening hours!</p>
                <input id='opening_hours' type="text" className="updateBBInput" placeholder="24/7" name="opening_hours" value={opening_hours} onChange={e => handleChange(e)}/> 
              </div>
            </div>
            
            <div className="updateBBFormDiv">
              <div className="updateBBInputWrapper">
                <label htmlFor="longitude" className='updateBBLabel'>Longitude:</label>
                <p id='errorLongitude' className='errorMessage'>Please fill in exact Longitude!</p>
                <input id='longitude' type="number" className="updateBBInput" placeholder="83.997056" name="longitude" value={longitude} onChange={e => handleChange(e)}/> 
              </div>
              <div className="updateBBInputWrapper">
                <label htmlFor="latitude" className='updateBBLabel'>Latitude:</label>
                <p id='errorLatitude' className='errorMessage'>Please fill the Latitude!</p>
                <input id='latitude' type="number" className="updateBBInput" placeholder="28.236157" name="latitude" value={latitude} onChange={e => handleChange(e)}/> 
              </div>
            </div>

            <div className="updateBBFormDiv">
              <div className="updateBBSubmitWrapper">
                <input type="submit" className='updateBBSubmit' onClick={e => handleSubmit(e)} value="Update" />
              </div>
            </div>
          </div>
        </div>
      </div>
  )
}

export default UpdateBB